import React, { useState, useEffect } from 'react';

export default function Index(props) {

    useEffect(() => {
        
    }, []);

    return (
        <div>configuration page</div>
    );
}